import {
  CLEAN_ERROR,
  CREATE_APPLICATION,
  CREATE_APPLICATION_IS_ERROR,
  CREATE_APPLICATION_IS_PENDING,
  CREATE_PROPERTY,
  CREATE_PROPERTY_IS_ERROR,
  CREATE_PROPERTY_IS_PENDING,
  DELETE_APPLICATION,
  DELETE_APPLICATION_IS_ERROR,
  DELETE_APPLICATION_IS_PENDING,
  DELETE_PROPERTY,
  DELETE_PROPERTY_IS_ERROR,
  DELETE_PROPERTY_IS_PENDING,
  FETCH_APPLICATION_BUILD_APPLICATION,
  FETCH_APPLICATION_BUILD_APPLICATION_IN_USE,
  FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_ERROR,
  FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_PENDING,
  FETCH_APPLICATION_BUILD_APPLICATION_IS_ERROR,
  FETCH_APPLICATION_BUILD_APPLICATION_IS_PENDING,
  FETCH_APPLICATION_BY_ID,
  FETCH_APPLICATION_BY_ID_IS_ERROR,
  FETCH_APPLICATION_BY_ID_IS_PENDING,
  FETCH_APPLICATION_TYPE,
  FETCH_APPLICATION_TYPE_IS_ERROR,
  FETCH_APPLICATION_TYPE_IS_PENDING,
  FETCH_APPLICATIONS,
  FETCH_APPLICATIONS_IS_ERROR,
  FETCH_APPLICATIONS_IS_PENDING,
  FETCH_PROPERTY,
  FETCH_PROPERTY_IS_ERROR,
  FETCH_PROPERTY_IS_PENDING,
  FETCH_STOP_METHOD,
  FETCH_STOP_METHOD_IS_ERROR,
  FETCH_STOP_METHOD_IS_PENDING,
  SORT_APPLICATIONS,
  UPDATE_APPLICATION,
  UPDATE_APPLICATION_IS_ERROR,
  UPDATE_APPLICATION_IS_PENDING,
  UPDATE_PROPERTY,
  UPDATE_PROPERTY_IS_ERROR,
  UPDATE_PROPERTY_IS_PENDING,
} from 'services/GameHosting/Application/types';
import { SortDirection } from 'types/common/sorting';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  applications: [],
  sortBy: 'name',
  sortDirection: 'ASC' as SortDirection,
  params: {},
  properties: [],

  fetchApplicationsIsCompleted: false,
  fetchApplicationsIsPending: false,
  fetchApplicationsIsError: null,
  application: [],
  fetchApplicationByIdIsCompleted: false,
  fetchApplicationByIdIsPending: false,
  fetchApplicationByIdIsError: null,
  fetchPropertiesIsCompleted: false,
  fetchPropertiesIsPending: false,
  fetchPropertiesIsError: null,
  applicationBuild: [],
  fetchApplicationBuildByApplicationIsCompleted: false,
  fetchApplicationBuildByApplicationIsPending: false,
  fetchApplicationBuildByApplicationIsError: null,
  applicationBuildInUse: [],
  fetchApplicationBuildByApplicationInUseIsCompleted: false,
  fetchApplicationBuildByApplicationInUseIsPending: false,
  fetchApplicationBuildByApplicationInUseIsError: null,
  applicationTypes: [],
  fetchApplicationTypeIsCompleted: false,
  fetchApplicationTypeIsPending: false,
  fetchApplicationTypeIsError: null,

  stopMethod: [],
  fetchStopMethodIsCompleted: false,
  fetchStopMethodIsPending: false,
  fetchStopMethodIsError: null,
};

const CUD_PROPERTIES = {
  createApplicationIsCompleted: false,
  createApplicationIsPending: false,
  createApplicationIsError: null,
  updateApplicationIsCompleted: false,
  updateApplicationIsPending: false,
  updateApplicationIsError: null,
  deleteApplicationIsCompleted: false,
  deleteApplicationIsPending: false,
  deleteApplicationIsError: null,
  createPropertyIsCompleted: false,
  createPropertyIsPending: false,
  createPropertyIsError: null,
  deletePropertyIsCompleted: false,
  deletePropertyIsPending: false,
  deletePropertyIsError: null,
  fetchPropertiesIsCompleted: false,
  fetchPropertiesIsPending: false,
  fetchPropertiesIsError: null,
};

const applicationsReducer = (
  state = {
    ...INITIAL_STATE,
    ...CUD_PROPERTIES,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_APPLICATIONS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        applications: sort(action.applications, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: (state.params as $TSFixMe).sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchApplicationsIsCompleted: true,
        fetchApplicationsIsPending: false,
        fetchApplicationsIsError: null,
      };
    case FETCH_APPLICATIONS_IS_PENDING:
      return {
        ...state,
        fetchApplicationsIsCompleted: false,
        fetchApplicationsIsPending: true,
        fetchApplicationsIsError: null,
      };
    case FETCH_APPLICATIONS_IS_ERROR:
      return {
        ...state,
        fetchApplicationsIsCompleted: true,
        fetchApplicationsIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchApplicationsIsError: action.error,
      };

    case FETCH_APPLICATION_BY_ID:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        application: action.data,
        fetchApplicationByIdIsCompleted: true,
        fetchApplicationByIdIsPending: false,
        fetchApplicationByIdIsError: null,
      };
    case FETCH_APPLICATION_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchApplicationByIdIsCompleted: false,
        fetchApplicationByIdIsPending: true,
        fetchApplicationByIdIsError: null,
      };
    case FETCH_APPLICATION_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchApplicationByIdIsCompleted: true,
        fetchApplicationByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchApplicationByIdIsError: action.error,
      };

    case CREATE_APPLICATION:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        applications: addNew(action.application, state.applications),
        createApplicationIsCompleted: true,
        createApplicationIsPending: false,
        createApplicationIsError: null,
      };
    case CREATE_APPLICATION_IS_PENDING:
      return {
        ...state,
        createApplicationIsCompleted: false,
        createApplicationIsPending: true,
        createApplicationIsError: null,
      };
    case CREATE_APPLICATION_IS_ERROR:
      return {
        ...state,
        createApplicationIsCompleted: true,
        createApplicationIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createApplicationIsError: action.error,
      };

    case UPDATE_APPLICATION: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const indexToUpdate = state.applications.findIndex((application) => (application as $TSFixMe).id === action.application.id);

      return {
        ...state,
        applications: state.applications.map((item, index) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...item,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.application,
          };
        }),
        updateApplicationIsCompleted: true,
        updateApplicationIsPending: false,
        updateApplicationIsError: null,
      };
    }

    case UPDATE_APPLICATION_IS_PENDING:
      return {
        ...state,
        updateApplicationIsCompleted: false,
        updateApplicationIsPending: true,
        updateApplicationIsError: null,
      };
    case UPDATE_APPLICATION_IS_ERROR:
      return {
        ...state,
        updateApplicationIsCompleted: true,
        updateApplicationIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateApplicationIsError: action.error,
      };

    case DELETE_APPLICATION: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const index = state.applications.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        applications: [...state.applications.slice(0, index), ...state.applications.slice(index + 1)],
        deleteApplicationIsCompleted: true,
        deleteApplicationIsPending: false,
        deleteApplicationIsError: null,
      };
    }

    case DELETE_APPLICATION_IS_PENDING:
      return {
        ...state,
        deleteApplicationIsCompleted: false,
        deleteApplicationIsPending: true,
        deleteApplicationIsError: null,
      };
    case DELETE_APPLICATION_IS_ERROR:
      return {
        ...state,
        deleteApplicationIsCompleted: false,
        deleteApplicationIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteApplicationIsError: action.error,
      };
    case FETCH_PROPERTY:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        properties: action.data,
        fetchPropertiesIsCompleted: true,
        fetchPropertiesIsPending: false,
        fetchPropertiesIsError: null,
      };
    case FETCH_PROPERTY_IS_PENDING:
      /* NOTE: I'm leaving properties as an empty array during pending state, because if something happens
                     the properties will be already cleant by then
            */
      return {
        ...state,
        fetchPropertiesIsCompleted: false,
        fetchPropertiesIsPending: true,
        fetchPropertiesIsError: null,
      };
    case FETCH_PROPERTY_IS_ERROR:
      return {
        ...state,
        fetchPropertiesIsCompleted: true,
        fetchPropertiesIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchPropertiesIsError: action.error,
      };
    case CREATE_PROPERTY:
      return {
        ...state,
        createPropertyIsCompleted: true,
        createPropertyIsPending: false,
        createPropertyIsError: null,
      };
    case CREATE_PROPERTY_IS_PENDING:
      return {
        ...state,
        createPropertyIsCompleted: false,
        createPropertyIsPending: true,
        createPropertyIsError: null,
      };
    case CREATE_PROPERTY_IS_ERROR:
      return {
        ...state,
        createPropertyIsCompleted: true,
        createPropertyIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createPropertyIsError: action.error,
      };
    case DELETE_PROPERTY:
      return {
        ...state,
        deletePropertyIsCompleted: true,
        deletePropertyIsPending: false,
        deletePropertyIsError: null,
      };
    case DELETE_PROPERTY_IS_PENDING:
      return {
        ...state,
        deletePropertyIsCompleted: false,
        deletePropertyIsPending: true,
        deletePropertyIsError: null,
      };
    case DELETE_PROPERTY_IS_ERROR:
      return {
        ...state,
        deletePropertyIsCompleted: true,
        deletePropertyIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deletePropertyIsError: action.error,
      };

    case FETCH_APPLICATION_BUILD_APPLICATION:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        applicationBuild: action.data,
        fetchApplicationBuildByApplicationIsCompleted: true,
        fetchApplicationBuildByApplicationIsPending: false,
        fetchApplicationBuildByApplicationIsError: null,
      };
    case FETCH_APPLICATION_BUILD_APPLICATION_IS_PENDING:
      return {
        ...state,
        fetchApplicationBuildByApplicationIsCompleted: false,
        fetchApplicationBuildByApplicationIsPending: true,
        fetchApplicationBuildByApplicationIsError: null,
      };
    case FETCH_APPLICATION_BUILD_APPLICATION_IS_ERROR:
      return {
        ...state,
        fetchApplicationBuildByApplicationIsCompleted: true,
        fetchApplicationBuildByApplicationIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchApplicationBuildByApplicationIsError: action.error,
      };

    case FETCH_APPLICATION_BUILD_APPLICATION_IN_USE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        applicationBuildInUse: action.data,
        fetchApplicationBuildByApplicationInUseIsCompleted: true,
        fetchApplicationBuildByApplicationInUseIsPending: false,
        fetchApplicationBuildByApplicationInUseIsError: null,
      };
    case FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_PENDING:
      return {
        ...state,
        fetchApplicationBuildByApplicationInUseIsCompleted: false,
        fetchApplicationBuildByApplicationInUseIsPending: true,
        fetchApplicationBuildByApplicationInUseIsError: null,
      };
    case FETCH_APPLICATION_BUILD_APPLICATION_IN_USE_IS_ERROR:
      return {
        ...state,
        fetchApplicationBuildByApplicationInUseIsCompleted: true,
        fetchApplicationBuildByApplicationInUseIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchApplicationBuildByApplicationInUseIsError: action.error,
      };

    case FETCH_APPLICATION_TYPE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        applicationTypes: action.data,
        fetchApplicationTypeIsCompleted: true,
        fetchApplicationTypeIsPending: false,
        fetchApplicationTypeIsError: null,
      };
    case FETCH_APPLICATION_TYPE_IS_PENDING:
      return {
        ...state,
        fetchApplicationTypeIsCompleted: false,
        fetchApplicationTypeIsPending: true,
        fetchApplicationTypeIsError: null,
      };
    case FETCH_APPLICATION_TYPE_IS_ERROR:
      return {
        ...state,
        fetchApplicationTypeIsCompleted: true,
        fetchApplicationTypeIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchApplicationTypeIsError: action.error,
      };

    case FETCH_STOP_METHOD:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        stopMethod: action.data,
        fetchStopMethodIsCompleted: true,
        fetchStopMethodIsPending: false,
        fetchStopMethodIsError: null,
      };
    case FETCH_STOP_METHOD_IS_PENDING:
      return {
        ...state,
        fetchStopMethodIsCompleted: false,
        fetchStopMethodIsPending: true,
        fetchStopMethodIsError: null,
      };
    case FETCH_STOP_METHOD_IS_ERROR:
      return {
        ...state,
        fetchStopMethodIsCompleted: true,
        fetchStopMethodIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchStopMethodIsError: action.error,
      };

    case UPDATE_PROPERTY: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const indexToUpdate = state.properties.findIndex((property) => (property as $TSFixMe).id === action.property.id);

      if (indexToUpdate < 0) {
        return { ...state, updatePropertyIsCompleted: false, updatePropertyIsPending: false, updatePropertyIsError: true };
      }

      return {
        ...state,
        properties: state.properties.map((item, index) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...item,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.application,
          };
        }),
        updatePropertyIsCompleted: true,
        updatePropertyIsPending: false,
        updatePropertyIsError: null,
      };
    }

    case UPDATE_PROPERTY_IS_PENDING:
      return {
        ...state,
        updatePropertyIsCompleted: false,
        updatePropertyIsPending: true,
        updatePropertyIsError: null,
      };
    case UPDATE_PROPERTY_IS_ERROR:
      return {
        ...state,
        updatePropertyIsCompleted: true,
        updatePropertyIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updatePropertyIsError: action.error,
      };

    case SORT_APPLICATIONS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        applications: sort(state.applications, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    case CLEAN_ERROR:
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (state[action.reducerProperty] && state[action.reducerProperty][action.errorIndex]) {
        return {
          ...state,

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          [action.reducerProperty]:
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            action.mode === 'property'
              ? null
              : // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                [...state[action.reducerProperty].slice(0, action.errorIndex), ...state[action.reducerProperty].slice(action.errorIndex + 1)],
        };
      }

      return {
        ...state,
      };
    case 'RESET_APPLICATION_REDUCER':
    case 'RESET_REDUCER':
      return {
        ...INITIAL_STATE,
        ...CUD_PROPERTIES,
      };
    default:
      return state;
  }
};

export default applicationsReducer;
